module.exports = __webpack_public_path__ + "static/media/295898.a5e7a47c.png";